var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 782.88 185.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#a37b50;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "disgusted"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M185.22,62.29A26.54,26.54,0,0,0,190.4,47C190.4,21,147.78,0,95.2,0S0,21,0,47C0,63.28,16.85,77.64,42.42,86.06c-18.72,18.16-28.07,37.19-22.61,50.43C25.9,151.27,48.86,155,77.47,148c-1.08,12.14,1.2,21.78,7.24,26.88,15,12.64,47.41-7.36,72.43-44.67,12.6-18.8,20.92-38.39,24.16-54.84A40.38,40.38,0,0,0,185.22,62.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M597.66,68.73a26.61,26.61,0,0,1-5.18-15.32c0-25.94,42.62-47,95.2-47s95.2,21,95.2,47c0,16.31-16.85,30.67-42.42,39.1,18.72,18.15,28.07,37.18,22.61,50.42C757,157.71,734,161.39,705.41,154.41c1.08,12.14-1.19,21.78-7.24,26.88-15,12.64-47.41-7.36-72.43-44.67-12.6-18.8-20.92-38.39-24.16-54.84A40.38,40.38,0,0,1,597.66,68.73Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset1);
export default __webpack_public_path__ + "static/media/Asset 1.17469e43.svg";
export { ForwardRef as ReactComponent };